import {
  FC,
  JSX
} from "react";
import {
  Text,
  View
} from "react-native";
import {
  labelClass,
  requiredLabelClass,
  textInputClass
} from "@/app/(main)/profile/Feedback";
import CustomButton from "@/app/components/CustomButton";
import { toast } from "sonner-native";
import AlertIcon from "@/assets/icons/main/redAlert.svg";
import type { TypedMutationTrigger } from '@reduxjs/toolkit/query/react';
import useInnForm, { InnFormValues } from "@/_hooks/useInnForm";
import { ICreateReportResponse } from "@/_store/company/contracts";
import Spin from "@/app/components/Spin";
import { isInnValid } from "@/_utils/validation";
import { usePlatformStyles } from "@/_hooks/usePlatformStyles";
import useFocus from "@/_hooks/useFocus";
import StyledTextInput from "@/app/components/StyledTextInput";

export const wrapperLabelBlockClass: string = "flex-row items-start mt-6";
const infoRoundedBannerClass: string = "w-fit text-blue-500 text-base bg-blue-light px-3 py-1 rounded-3xl";
export const titleClass: string = "my-3 text-2xl text-black font-medium";
export const subTitleClass: string = "text-gray text-base";


interface ICompanyCheckProps {
  createReport: TypedMutationTrigger<
    ICreateReportResponse,
    InnFormValues,
    any
  >;
  isLoading: boolean;
}

const CompanyCheck: FC<ICompanyCheckProps> = ({
  createReport,
  isLoading
}) => {
  const {
    inn,
    handleInnChange,
    resetForm,
    hasNoValues
  } = useInnForm();

  const { webOutlineNone } = usePlatformStyles();
  const innFieldFocus = useFocus();

  const isButtonDisabled: boolean = hasNoValues || isLoading || !isInnValid(inn);

  const handleSubmit = async (): Promise<void> => {
    try {
      if (hasNoValues) return;

      await createReport({ inn }).unwrap();

      resetForm();
    } catch (err) {
      console.error("При отправке запроса произошла ошибка:", err);
      toast.error("При отправке запроса произошла ошибка. Пожалуйста, попробуйте снова позже.", {
        icon: <AlertIcon />,
      });
    }
  };

  const loadingView: JSX.Element = (
    <View className="w-full mt-32 flex-col">
      <Spin />
      <Text className="text-black text-base text-center mt-4">
        Готовим данные, еще чуть-чуть...
      </Text>
    </View>
  )

  if (isLoading) {
    return (
      loadingView
    );
  }

  return (
    <>
      <Text className={infoRoundedBannerClass}>Безлимит</Text>
      <Text className={titleClass}>Проверка компании или ИП</Text>
      <Text className={subTitleClass}>Пожалуйста, введите необходимые данные компании или индивидуального предпринимателя.</Text>
      <View className={wrapperLabelBlockClass}>
        <Text className={requiredLabelClass}>*</Text>
        <Text className={labelClass}>ИНН компании</Text>
      </View>

      <StyledTextInput
        className={textInputClass}
        placeholder="Введите ИНН"
        value={inn}
        maxLength={12}
        style={webOutlineNone}
        onFocus={innFieldFocus.onFocus}
        isFocused={innFieldFocus.isFocused}
        onBlur={innFieldFocus.onBlur}
        onChangeText={handleInnChange}
        keyboardType="numeric"
      />
      <CustomButton
        title="Проверить"
        type="primary"
        className="mb-6"
        onPress={handleSubmit}
        disabled={isButtonDisabled}
      />
    </>
  );
};


export default CompanyCheck;
